<template>
    <div ref="acc" :class="[stylename]">

        <div :class="[IsOpened?'acc_header':'acc_header_collapsed']">
            <slot name="acc_header"></slot>
        </div>
        
        <transition name="accordion"
        v-on:before-enter="acc_beforeEnter" v-on:enter="acc_enter"
        v-on:before-leave="acc_beforeLeave" v-on:leave="acc_leave">
            <div class="acc_body" v-show="IsOpened">
                <div class="acc_body-inner">
                    <slot name="acc_content"></slot>
                </div>
            </div>
        </transition>

        <div class="acc_footer">
            <div class="acc_footer_button" :style="{'transform': IsOpened?'rotate(180deg)':'rotate(0)'}"  @click="Toggle">
                <i class="fal fa-chevron-down"></i>
            </div>
        </div>
    </div>
</template>


<script>
import Vue from 'vue'

export default {
  name: 'grccms_accordion',
  components: {
  },
  props: {
    cms_stylename: String,
    cms_opened: String,
    cms_lazyload: String,
  },
  data () {
      return {
        stylename: this.cms_stylename,
        opened: this.cms_opened,
        LazyLoad: this.cms_lazyload,
        IsOpened:false,
      }
  },
  model: {
  },  
  methods:{
    acc_beforeEnter: function(el) {
      el.style.maxHeight = '0';
    },
    acc_enter: function(el) {
      el.style.maxHeight = el.scrollHeight + 'px';
    },
    acc_beforeLeave: function(el) {
      el.style.maxHeight = el.scrollHeight + 'px';
    },
    acc_leave: function(el) {
      el.style.maxHeight = '0';
    },      

    SetIsOpened(pValue)
    {
        this.IsOpened = pValue;
    },

    SetLazyLoad(pValue)
    {
      if (pValue)
      {
        this.LazyLoad = "true";
      }
      else
      {
        this.LazyLoad = "false";
      }
    },

    Toggle()
    {
      if (this.IsOpened == false)
      {
        if (this.LazyLoad == "true")
        {
          this.$emit("onlazyload");
          return;
        }
      }

      if (this.IsOpened)
      {
        window.scrollTo(0, grccomp_findPos(this.$refs.acc).top - 80);
      }

      this.IsOpened = !this.IsOpened;

    },

  },
  created()
  {
    if (typeof this.stylename == "undefined")
    {
      this.stylename = "";
    }

    if (typeof this.opened == "undefined")
    {
      this.opened = "false";
    }

    if (typeof this.LazyLoad == "undefined")
    {
      this.LazyLoad = "false";
    }


  },
  mounted()
  {
      if (this.opened == "true")
      {
        this.SetIsOpened(true);
      }

  }

}

</script>

<style scoped>



</style>




